import {
  Box,
  Button,
  Container,
  Grid,
  AppBar,
  Toolbar,
  LinearProgress,
  LinearProgressProps,
  Typography,
  IconButton,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useAppContext } from "../../../libs/app-core/AppContext";
import {
  linear_content_style,
  linear_h,
  linear_item,
  linear_v,
} from "../../../libs/linear-layout/LinearLayout";
import { MemberDAO, useMember } from "../../dao/MemberDAO";
import { UniFuncDAO } from "../../dao/UniFuncDAO";
import { R } from "../../R";
import { useGV } from "../../GV";
import { useEffect, useState } from "react";
import { AuthDAO } from "../../dao/AuthDAO";
import TabPage from "../../components/TabPage";
import { UniAnswerDAO } from "../../dao/UniAnswerDAO";
import { UniAnswer } from "../../dao/UniAnswer";
import { UniFunc } from "../../dao/UniFunc";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { NavigateTo_FrmCommonQuest_Async } from "../FrmProjectEditor/UcUniFuncPills";
import { OpenPageFrmSpwkQuest_HoChen_Async } from "../FrmMemberLogin";
import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import Label from "../../../libs/rhf-mui/ui/Label";
import AuthHelper from "../../heplers/AuthHelper";
import LogoutIcon from "@mui/icons-material/Logout";
import React from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../../components/LanguageSelector";
import MemberNavbar from "../../components/MemberNavbar";

type Props = {};
const FrmMemberTodo = (props: Props) => {
  const [searchParams] = useSearchParams(); // UrlQueryParams
  const member_guid = searchParams.get("member_guid") ?? "";
  //---------------------------------------------------------------

  const ctx = useAppContext();

  const GV = useGV();

  const { _Member } = useMember(member_guid);

  const { t } = useTranslation();

  const AppBarTabIndex = "tab待作表單";
  const [_answerList, set_answerList] = useState<UniAnswer[]>([]);
  const [_funcList, set_funcList] = useState<UniFunc[]>([]);

  /** 重新取得登入資訊(暫時先這樣處理)
   * React 重新整理後，會遺失 State
   * 此畫面為最主要的後台畫面，暫時在此恢復 GV.user
   * FIXME: 更正確的恢復方式
   */
  useEffect(() => {
    AuthDAO.Info()
      .then((res) => {
        GV.setUser(res);
      })
      .catch((error) => {
        GV.setUser(null);
      })
      .finally(() => {});
    LoadCommonQuest();
  }, [member_guid]);

  async function LoadCommonQuest() {
    const guid = member_guid;
    try {
      const _answerList = await UniAnswerDAO.WS_Select_ByMemberGuid(guid);
      const _funcList = await UniFuncDAO.WS_SelectALL();
      set_answerList(_answerList);
      set_funcList(_funcList);
    } catch (error) {
      // 處理錯誤
    }
  }
  async function SetQuestDoneDt() {
    if (_Member != null) {
      await MemberDAO.WS_UpdateAllQuestDoneDt(_Member);
    } else {
      throw new_ErrorAlert(`8761394 member為null`);
    }
  }

  return (
    <Box style={linear_content_style}>
      {/* 外框架 */}
      <Grid {...linear_h}>
        <Grid {...linear_item} width={0} bgcolor="#FFCCFF">
          {/* 左側主檔 Master */}
          <Box bgcolor="#CCCCFF"></Box>
        </Grid>
        <Grid {...linear_item} flex={1} bgcolor="">
          {/* 中間列表 Details */}
          {render_Detail()}
        </Grid>
      </Grid>
    </Box>
  );

  function render_FormList() {
    let CompletedCount = 0;
    const AllCount = _answerList.length;
    _answerList.forEach((answer) => {
      if (answer.IsQuestDone()) {
        CompletedCount++;
      }
    });
    const progress = (CompletedCount / AllCount) * 100;
    if (progress === 100 && dayjs(_Member?.all_quest_done_dt).year() === 2999) {
      SetQuestDoneDt();
    } else {
      //pass
    }
    return (
      <Box style={linear_content_style} bgcolor={R.color.paper}>
        <Container sx={{ height: "100%", pb: 1, pt: 1 }} maxWidth={"xs"}>
          <Grid {...linear_v}>
            <Label
              sx={{
                typography: { fontSize: "40px" },
              }}
            >
              {_Member?.member_name}{" "}
              {progress === 100 ? t("已完成") : t("未完成")}
            </Label>
            <Box height={50} sx={{ mb: 2, pr: 2 }}>
              <LinearProgressWithLabel
                variant="determinate"
                value={progress}
                sx={{ height: "44px" }}
              />
            </Box>
            <Grid {...linear_item} container spacing={2}>
              {_answerList.map((answer) => {
                return (
                  <React.Fragment key={answer.guid}>
                    <Grid item xs={12}>
                      {render_問卷表單按鈕(answer)}
                    </Grid>
                  </React.Fragment>
                );
              })}
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }

  function render_問卷表單按鈕(answer: UniAnswer) {
    let DONE_COLOR = "#499F68";

    let UNDONE_COLOR = "#D05353";

    let FORE_COLOR = "#2A2B2E"; //'#2A2B2E';

    //#region 取得按鈕文字
    let button_text = "???";
    const icon = answer.IsQuestDone() ? (
      <CheckCircle />
    ) : (
      <RadioButtonUnchecked />
    );
    const bgcolor = answer.IsQuestDone() ? DONE_COLOR : UNDONE_COLOR;
    if (answer.IsSpwk()) {
      // 特作問卷
      button_text = t("健檢基本資料問卷");
    } else {
      // 一般問卷

      const matchedFunc = _funcList.filter(
        (func) => func.func_code === answer.func_code
      );
      button_text = t(matchedFunc[0].func_title);
    }
    //#endregion
    return (
      <>
        <Button
          sx={{ py: 1.5, bgcolor: bgcolor, color: FORE_COLOR }}
          fullWidth
          key={answer.guid}
          variant="contained"
          onClick={async () => {
            btn_問卷表單_Click(answer);
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            {icon}

            <Typography sx={{ textAlign: "left" }}>
              {button_text}
              <br />
              {answer.func_guid === "_F04"
                ? t("「今年度滿45歲者需填寫」")
                : undefined}
            </Typography>
          </Box>
        </Button>
      </>
    );
  }

  async function btn_問卷表單_Click(answer: UniAnswer) {
    if (answer.IsSpwk()) {
      // 特作問卷
      // TODO
      await OpenPageFrmSpwkQuest_HoChen_Async(
        answer.member_guid,
        "ALL",
        "ALL",
        ctx
      );
    } else {
      // 一般問卷
      if (answer.func_guid == null) {
        throw new_ErrorAlert("464337413");
      }

      await NavigateTo_FrmCommonQuest_Async(
        ctx,
        answer.member_guid,
        answer.func_guid
      );
    }
  }

  function render_AppBar() {
    return (
      <>
        <AppBar position="static" sx={{ bgcolor: R.color.app_bar }}>
          <Toolbar variant="dense">
            <Box sx={{ flexGrow: 1 }}></Box>
          </Toolbar>
          {render_header()}
        </AppBar>
      </>
    );
  }

  function render_Detail() {
    return (
      <>
        <Grid {...linear_v}>
          <Grid {...linear_item}>{render_AppBar()}</Grid>
          <Grid {...linear_item} flex={1}>
            <Box style={linear_content_style} sx={{ bgcolor: R.color.paper }}>
              <TabPage
                tab_key={"tab待作表單"}
                curr_tab={AppBarTabIndex}
                sx={{}}
              >
                <Box sx={{ height: "100%" }}>{render_FormList()}</Box>
              </TabPage>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }
  function LinearProgressWithLabel(
    props: LinearProgressProps & { value: number }
  ) {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="h3" color="text.secondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }
  function render_header() {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              pl: 2,
            }}
          >
            <Label variant="subtitle2" component="div" sx={{ flexGrow: 1 }}>
              {/* 需做表單列表 */}
              {t("問卷填答")}
            </Label>

            <MemberNavbar />
          </Box>
        </AppBar>
      </Box>
    );
  }
  function btn_Logout_Click() {
    if (GV == null) {
      throw new_ErrorAlert("ERROR! GV==null !!!");
    }

    AuthHelper.Logout(GV, ctx);
  }
};

export default FrmMemberTodo;
